import * as React from 'react';
import { useResizeDetector } from 'react-resize-detector';

export function withResizeDetector(WrappedComponent: any) {
    return function WithResize(props: any) {
        const { width, height, ref } = useResizeDetector({
            handleWidth: true,
            handleHeight: true,
        });

        return (
            <div ref={ref}>
                <WrappedComponent {...props} width={width} height={height} />
            </div>
        );
    };
}
